/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RemoveShieldsDto = {
  /**
   * 제거 개수 (생략 시 범위 내 전부)
   */
  count?: number;
  /**
   * 제거 범위: active(미사용, 기본)/used(사용됨)/all(전부)
   */
  scope?: RemoveShieldsDto.scope;
};
export namespace RemoveShieldsDto {
  /**
   * 제거 범위: active(미사용, 기본)/used(사용됨)/all(전부)
   */
  export enum scope {
    ACTIVE = "active",
    USED = "used",
    ALL = "all",
  }
}
